var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.47461C17.4963 8.47461 18 8.97829 18 9.59961C18 10.2209 17.4963 10.7246 16.875 10.7246L1.125 10.7246C0.503679 10.7246 -7.63341e-08 10.2209 -4.91753e-08 9.59961C-2.20165e-08 8.97829 0.503679 8.47461 1.125 8.47461L16.875 8.47461Z",
    fill: "#FC686F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 1.72461C7.875 1.10329 8.37868 0.599609 9 0.599609C9.62132 0.599609 10.125 1.10329 10.125 1.72461V17.4746C10.125 18.0959 9.62132 18.5996 9 18.5996C8.37868 18.5996 7.875 18.0959 7.875 17.4746V1.72461Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.719190a4b20f8a67092f24ab51247463.svg";
export { ForwardRef as ReactComponent };